module.exports = __webpack_public_path__ + "img/logo.e8c93c51.png";